import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hg3",
  "use": "icon-hg3-usage",
  "viewBox": "0 0 1144 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1144 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hg3\"><path d=\"M3.132235 659.937882L122.337882 2.650353l266.721883 334.426353L775.830588 10.842353l-38.912 488.387765 397.071059 42.044235-491.941647 439.898353z\" fill=\"#d37416\" p-id=\"10854\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol